import { render, staticRenderFns } from "./AbkManagingEventsBox.vue?vue&type=template&id=691f0ce6&scoped=true&"
import script from "./AbkManagingEventsBox.vue?vue&type=script&lang=js&"
export * from "./AbkManagingEventsBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkManagingEventsBox.vue?vue&type=style&index=0&id=691f0ce6&lang=scss&scoped=true&"
import style1 from "./AbkManagingEventsBox.vue?vue&type=style&index=1&id=691f0ce6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691f0ce6",
  null
  
)

export default component.exports